import { Tag } from "antd"
import React from "react"

export const BetaTag = () => <Tag className="ant-tag-beta ml-8">Beta</Tag>
